import numbro from 'numbro';
import { isNilOrEmpty } from 'ramda-extension';
import { equals, either } from 'ramda';

export function getCurrencyFormatter(
  language = global.navigator?.language || 'en-US',
  options
) {
  const currencyFormatter = new Intl.NumberFormat(language, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  });

  return currencyFormatter.format;
}

const compactFormat = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  compactDisplay: 'short',
  maximumFractionDigits: 1,
});

export const compactFomatter = (number) => compactFormat.format(number);

export const fromCents = (number, { round = false } = {}) =>
  numbro(number)
    .divide(100)
    .formatCurrency({
      mantissa: round ? 0 : 2,
      optionalMantissa: true,
      thousandSeparated: true,
    });

export const plainNumber = (number) =>
  numbro(number).format({
    thousandSeparated: true,
  });

// TODO: Why is this rounding to integer dollars? i.e. $12 for 1234 cents?
export const centsToDollars = (number) => Math.round(number / 100);

export const isInt = (number) => number % 1 === 0;

export const isZero = equals(0);
export const isNilEmptyOrZero = either(isZero, isNilOrEmpty);
